module.exports = __webpack_public_path__ + "img/success.16e272f3.png";